import { SvgIcon } from "../../common/SvgIcon";
import Container from "../../common/Container";
import {
  BrandColumn,
  BrandCopy,
  BrandMark,
  FooterAnchor,
  FooterBottom,
  FooterGrid,
  FooterLink,
  FooterSection,
  FooterShell,
  FooterTitle,
  FooterGlow,
  LinkStack,
  SocialRow,
} from "./styles";
import { siteConfig } from "../../constants/site";

interface SocialLinkProps {
  href: string;
  src: string;
}

const Footer = () => {
  const SocialLink = ({ href, src }: SocialLinkProps) => {
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        key={src}
        aria-label={src}
      >
        <SvgIcon src={src} width="25px" height="25px" />
      </a>
    );
  };

  return (
    <FooterSection>
      <Container>
        <FooterShell>
          <FooterGlow />
          <FooterGrid>
            <BrandColumn>
              <BrandMark
                src="/img/new/logo.png"
                alt="You&Me Indian dating logo"
                width="120"
                height="120"
                loading="lazy"
                decoding="async"
              />
              <BrandCopy>
                Do you have any question? Feel free to reach out.
              </BrandCopy>
              <SocialRow>
                <SocialLink href={siteConfig.facebookUrl} src="facebook.svg" />
              </SocialRow>
            </BrandColumn>

            <div>
              <FooterTitle>Explore</FooterTitle>
              <LinkStack aria-label="Explore pages">
                <FooterLink to="/contact">Let's Chat</FooterLink>
                <FooterLink to="/download">Download App</FooterLink>
                <FooterLink to="/child-safety-standards">
                  Child Safety Standards
                </FooterLink>
              </LinkStack>
            </div>

            <div>
              <FooterTitle>Legal</FooterTitle>
              <LinkStack aria-label="Legal pages">
                <FooterLink to="/privacy">Privacy Policy</FooterLink>
                <FooterLink to="/terms">Terms and Conditions</FooterLink>
              </LinkStack>
            </div>

            <div>
              <FooterTitle>Regional blogs</FooterTitle>
              <LinkStack aria-label="Blog pages">
                <FooterLink to="/indian-dating-in-uk">Indian Dating in UK</FooterLink>
                <FooterLink to="/indian-dating-in-europe">
                  Indian Dating in Europe
                </FooterLink>
                <FooterLink to="/indian-dating-in-usa">Indian Dating in USA</FooterLink>
                <FooterLink to="/indian-dating-in-canada">
                  Indian Dating in Canada
                </FooterLink>
                <FooterLink to="/indian-dating-in-australia">
                  Indian Dating in Australia
                </FooterLink>
              </LinkStack>
            </div>
          </FooterGrid>
          <FooterBottom>
            <span>© 2026 You&Me. All rights reserved.</span>
            <FooterAnchor href={`mailto:${siteConfig.supportEmail}`}>
              {siteConfig.supportEmail}
            </FooterAnchor>
          </FooterBottom>
        </FooterShell>
      </Container>
    </FooterSection>
  );
};

export default Footer;
